export default __webpack_public_path__ + "static/media/bathroom2.bdb9d147.jpg";